import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { initSupabase } from '@/lib/supabase'
import { useAuthStore } from '@/stores/auth'
import { useToast } from '@/hooks/useToast'

export function AuthCallbackPage() {
  const navigate = useNavigate()
  const { setSession } = useAuthStore()
  const { showToast } = useToast()

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const supabase = await initSupabase()
        const { data: { session }, error } = await supabase.auth.getSession()

        if (error) throw error

        if (!session) {
          showToast('Authentication failed. Please try again.', 'error')
          navigate('/login', { replace: true })
          return
        }

        setSession(session)

        // Detect new user: created_at within last 60 seconds
        const user = session.user
        const createdAt = new Date(user.created_at).getTime()
        const now = Date.now()
        const isNewUser = now - createdAt < 60_000

        if (isNewUser) {
          navigate('/welcome', { replace: true })
        } else {
          navigate('/dashboard', { replace: true })
        }
      } catch (error) {
        showToast(error instanceof Error ? error.message : 'Authentication failed', 'error')
        navigate('/login', { replace: true })
      }
    }

    handleCallback()
  }, [navigate, setSession, showToast])

  return (
    <div className="min-h-screen flex items-center justify-center bg-white dark:bg-[#0f172a]">
      <div className="flex flex-col items-center gap-4">
        <div className="w-10 h-10 border-4 border-[#4f46e5] border-t-transparent rounded-full animate-spin" />
        <p className="text-slate-500 dark:text-slate-400 text-sm">Completing sign in...</p>
      </div>
    </div>
  )
}
